"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
var util_1 = require("./util");
exports.Util = util_1.default;
var Cookie = require("js-cookie");
var lodash_1 = require("lodash");
var next_1 = require("@alifd/next");
var util_2 = require("./util");
exports.GovCookie = util_2.GovCookie;
var regDeviceGroupUrl = "/form/api/nologin/device/regDeviceGroup";
var regDeviceUrl = "/form/api/nologin/device/regDevice";
var createTaskUrl = "/form/api/nologin/device/createTask";
var CookieValue = {
    groupId: "groupId",
    deviceId: "deviceId",
    govAuthCode: "govAuthCode",
};
var Task = /** @class */ (function () {
    function Task(options) {
        var _this = this;
        // 请求上下文,确认幂等需求的
        this.context = {};
        this.options = {
            domain: ".zjzwfw.gov.cn",
            expires: 999,
            path: "/",
        };
        Object.keys(options).forEach(function (key) {
            _this.options[key] = options[key];
        });
    }
    Task.prototype.regDeviceGroup = function (departmentId, departmentName) {
        return __awaiter(this, void 0, void 0, function () {
            var groupId, deviceId, result;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        groupId = Cookie.get(CookieValue.groupId);
                        deviceId = Cookie.get(CookieValue.deviceId);
                        if (!(!groupId || !deviceId)) return [3 /*break*/, 3];
                        return [4 /*yield*/, util_1.default.post(regDeviceGroupUrl, {
                                code: "",
                                departmentId: departmentId || "",
                                departmentName: departmentName || "",
                                name: "",
                            })];
                    case 1:
                        result = _a.sent();
                        groupId = lodash_1.get(result, "data");
                        if (!groupId) return [3 /*break*/, 3];
                        Cookie.set(CookieValue.groupId, groupId, {
                            domain: this.options.domain,
                            path: this.options.path,
                            expires: this.options.expires,
                        });
                        return [4 /*yield*/, this.regDevice(groupId)];
                    case 2:
                        deviceId = _a.sent();
                        Cookie.set(CookieValue.deviceId, deviceId, {
                            domain: this.options.domain,
                            path: this.options.path,
                            expires: this.options.expires,
                        });
                        _a.label = 3;
                    case 3: return [2 /*return*/, { groupId: groupId, deviceId: deviceId }];
                }
            });
        });
    };
    Task.prototype.regDevice = function (groupId) {
        return __awaiter(this, void 0, void 0, function () {
            var _a, data;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0: return [4 /*yield*/, util_1.default.post(regDeviceUrl, {
                            acceptTaskTypes: [],
                            /** 组编码，与pc设备标识一致 */
                            groupCode: groupId,
                            /** 设备标识，前端生成 */
                            identity: groupId,
                            /** 设备名称，前端生成 */
                            name: util_1.default.getUuid(),
                            /** 设备角色，pc用master，pad用slave */
                            role: "master",
                            /** 设备类型，pc或者pad */
                            type: "pc",
                            /** 工作状态，online或者offline */
                            workStatus: "online",
                        })];
                    case 1:
                        _a = (_b.sent()).data, data = _a === void 0 ? "" : _a;
                        return [2 /*return*/, data];
                }
            });
        });
    };
    Task.prototype.createTask = function (type, request) {
        return __awaiter(this, void 0, void 0, function () {
            var _a, _b, data, _c, success, error_1;
            return __generator(this, function (_d) {
                switch (_d.label) {
                    case 0:
                        _d.trys.push([0, 2, , 3]);
                        return [4 /*yield*/, util_1.default.post(createTaskUrl, {
                                processDeviceId: "",
                                deviceGroupCode: Cookie.get(CookieValue.groupId) || "",
                                sourceDeviceId: Cookie.get(CookieValue.deviceId) || "",
                                govAuthCode: Cookie.get(CookieValue.govAuthCode) || "",
                                type: type,
                                request: request,
                                context: this.context,
                            })];
                    case 1:
                        _a = _d.sent(), _b = _a.data, data = _b === void 0 ? "" : _b, _c = _a.success, success = _c === void 0 ? false : _c;
                        //
                        if (!success) {
                            next_1.Message.notice("任务创建失败");
                            return [2 /*return*/, ""];
                        }
                        return [2 /*return*/, data];
                    case 2:
                        error_1 = _d.sent();
                        throw error_1;
                    case 3: return [2 /*return*/];
                }
            });
        });
    };
    Task.prototype.updateTask = function (status, taskId) {
        return __awaiter(this, void 0, void 0, function () {
            var success, error_2;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 3]);
                        return [4 /*yield*/, util_1.default.post("/form/api/nologin/device/updateTask", {
                                /** 处理任务设备id, pc或者pad设备标志 */
                                deviceIdentity: Cookie.get(CookieValue.groupId) || "",
                                /** 任务状态, pending=待处理，processing=处理中，aborted=终止，success=成功，failed=失败，expired=失效。 */
                                targetStatus: status,
                                /** 任务id */
                                taskId: taskId,
                            })];
                    case 1:
                        success = (_a.sent()).success;
                        return [2 /*return*/, success ? true : false];
                    case 2:
                        error_2 = _a.sent();
                        next_1.Message.error("更新任务失败～");
                        return [2 /*return*/, false];
                    case 3: return [2 /*return*/];
                }
            });
        });
    };
    Task.prototype.queryTask = function (type, code, status) {
        return __awaiter(this, void 0, void 0, function () {
            var params, data;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        params = {
                            deviceIdentity: Cookie.get(CookieValue.deviceId) || "",
                            groupCode: Cookie.get(CookieValue.groupId) || "",
                            taskId: code,
                            types: type ? [type] : null,
                            status: status,
                        };
                        return [4 /*yield*/, util_1.default.post("/form/api/nologin/device/queryTask", params)];
                    case 1:
                        data = (_a.sent()).data;
                        return [2 /*return*/, data];
                }
            });
        });
    };
    return Task;
}());
exports.default = Task;
